<template>
  <RouterView />
  <ModalWarning />
  <Modal
    v-if="opened"
    :message="modalMessage"
    :type="modalType"
    @close="closeModal"
  />
</template>

<script setup>
import ModalWarning from "@/components/ModalWarning/ModalWarning.vue";
import Modal from "@/components/Modal/Modal.vue";
import { onMounted, ref } from "vue";
import store from "./store";
import {
  loadMessages,
  getTranslationValues,
} from "./services/translation/translation.service.ts";
import { updateRoutes, addMenuRoutes } from "./services/router/router.service";
import { registerApps } from "./main.ts";
import { registerMicroApps, start } from "../es";
import { getSchemaId } from "./services/data/data.service";
import { deauthenticate } from "./services/user/user.service";
import { useRouter} from "vue-router"
const opened = ref(false);
const modalMessage = ref("");
const modalType = ref("");
const router = useRouter();
onMounted(async () => {
  if (window.location.href.toString().includes("eagente")) {
    document.body.classList.add("orange");
    const eagenteTheme = {
      layout: "rubick",
      menuPosition: "side",
      colorScheme: "orange",
      darkMode: false,
    };
    localStorage.setItem("theme", JSON.stringify(eagenteTheme));
  } else {
    if(localStorage.getItem("theme")) {
      if (window.location.href.toString().includes("iam")) {
        const theme = JSON.parse(localStorage.getItem("theme"));
        let colorScheme = theme.colorScheme;
        if(colorScheme == "orange") {
          colorScheme = "blue";
          const sydoneTheme = {
          layout: "rubick",
          menuPosition: "side",
          colorScheme: colorScheme,
          darkMode: false,
        };
        localStorage.setItem("theme", JSON.stringify(sydoneTheme));
        }
        document.body.classList.add(colorScheme);
      }
  }
  }
  updateRoutes();
  await store.dispatch("setMenuStore");

  window.addEventListener("message", (event) => awaitEvent(event), false);
  async function awaitEvent(event) {
    if (event.origin == window.location.origin) {
      if (event.data == "menuChange") {
        await store.dispatch("setMenuStore");
      } else if (event.data == "sign in") {
        //const schema = await getSchemaId();
        const url = window.location.href;

        var path = url.split("/")[3];
        if (path.includes("?")) {
          path = path.split("?")[0];
        }

        const dynamicApps = await registerApps();
        //dynamicApps.forEach(element => addSubAppViewDynamic(element.name, element.activeRule));
        registerMicroApps(dynamicApps);
        setTimeout(async () => {
          await store.dispatch("setMenuStore");
          fetchTranslation();
        }, 2000);
      } else if (event.data == "databaseSwitch") {
        modalMessage.value = "Database Switched!";
        opened.value = true;
        modalType.value = "Success!";
      } else if (event.data == "entitySwitch") {
        const schema = await getSchemaId();
        modalMessage.value = "Entity Switched!";
        opened.value = true;
        modalType.value = "Success!";
        const targetOrigin = window.location.origin;
        window.postMessage("forceMainMenuSwitch", targetOrigin);
      } else if (event.data == "schemaSwitch") {
        modalMessage.value = "Schema Switched!";
        opened.value = true;
        modalType.value = "Success!";
      } else if (event.data == "databaseSwitchFail") {
        modalMessage.value = "Database Not Switched! User is missing in database!";
        opened.value = true;
        modalType.value = "Error!";
      } else if (event.data == "schemaSwitchFail") {
        modalMessage.value = "Schema Not Switched!";
        opened.value = true;
        modalType.value = "Error!";
      } else if (event.data == "entitySwitchFail") {
        modalMessage.value = "Entity Is Not Switched!";
        opened.value = true;
        modalType.value = "Error!";
      } else if (
        event.data.type == "revisionFail" ||
        event.data.type == "approvalFail" ||
        event.data.type == "acceptanceFail" ||
        event.data.type == "publishingFail"
      ) {
        modalMessage.value = event.data.message;
        opened.value = true;
        modalType.value = "Error!";
      } else if (event.data == "dataSaved") {
        modalMessage.value = "Data Saved!";
        opened.value = true;
        modalType.value = "Success!";
      } else if(event.data == "dataNotSaved") {
        modalMessage.value = "Something went wrong!";
        opened.value = true;
        modalType.value = "Error!";
      } else if (event.data == "uploadSuccess") {
        modalMessage.value = "Upload Successful!";
        opened.value = true;
        modalType.value = "Success!";
      } else if(event.data == "uploadFail") {
        modalMessage.value = "Upload Was Not Successful!";
        opened.value = true;
        modalType.value = "Error!";
      } else if(event.data == "tooManyFiles") {
        modalMessage.value = "File Upload Limit is 10 Files!";
        opened.value = true;
        modalType.value = "Error!";
      } else if(event.data == "tooManyHTMLFiles") {
        modalMessage.value = "Only one HTML file can be uploaded at once!";
        opened.value = true;
        modalType.value = "Error!";
      } else if (event.data.type == "deletedNodes") {
        const tbIdsArray = event.data.message;
        for (var i=0; i<tbIdsArray.length; i++) {
            tbIdsArray[i] = " " + tbIdsArray[i];
          }
        modalMessage.value = "Deleted nodes tb_ids:" + tbIdsArray;
        opened.value = true;
        modalType.value = "Success!";
      } else if (event.data.type == "createdResources") {
        const resourceIdsArray = event.data.message;
        for (var a=0; a<resourceIdsArray.length; a++) {
            resourceIdsArray[a] = " " + resourceIdsArray[a];
          }
        modalMessage.value = "Created resources ids:" + resourceIdsArray;
        opened.value = true;
        modalType.value = "Success!";
      } else if (event.data.type == "routeUpdate") {
        const routesArray = event.data.message;
        await addMenuRoutes(routesArray);
      } else if (event.data.type == "routePush") {
        const route = event.data.message;
        if(route != 'management') {
        router.push('/management/'+route);
        } else {
          router.push('/management');
        }
      }
      else if(event.data == "deleteAccount") {
        modalMessage.value = "Once you delete your account, all data connected to this account, and connections to other entities / accounts will be permanently deleted!";
        opened.value = true;
        modalType.value = "Delete?";
      }
      else if (event.data.type == "languageChange") {
        fetchTranslation();
      } else if (event.data == "sign out") {
        deauthenticate();
      }
    }
  }
  start({
    sandbox: {
      experimentalStyleIsolation: true,
      //strictStyleIsolation: true,
    },
    singular: false,
  });
});
async function fetchTranslation() {
  var dataIds = await getTranslationValues();

  await loadMessages(dataIds);
}
function closeModal() {
  opened.value = false;
}
</script>
